import React from "react";
import { FormControl, FormLabel } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import "../alerts/Message.style.js";
import { MessageWithIcon } from "../alerts/MessageWithIcon.js";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
class StyledInputProps {
  label;
  labelVariant;
  labelPlacement;
  className;
  fullWidth;
  hasBottomSpacing;
  hint;
}
const useStyles = makeStyles()((theme) => ({
  formRow: {
    backgroundColor: "transparent",
    color: theme.custom.palette.content.bodyText,
    width: "100%"
  },
  formRowLabelCaption: {
    textTransform: "uppercase",
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
    letterSpacing: 1,
    fontWeight: 500,
    padding: theme.spacing(0.5, 0)
  },
  formRowLabelDefault: {
    color: theme.custom.palette.content.headingText,
    padding: theme.spacing(1, 0)
  },
  formRowSpacingBottom: {
    marginBottom: theme.spacing(2)
  },
  formRowWithLeftLabel: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    alignItems: "center",
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(1)
  },
  formRowHint: {
    color: theme.palette.secondary.main,
    gridColumn: 2
  }
}));
function withStyledInputLabel(WrappedComponent) {
  return function FormRow({ className, label, labelVariant = "caption", labelPlacement = "top", hint, ...props }) {
    const { classes, cx } = useStyles();
    return /* @__PURE__ */ React.createElement(
      FormControl,
      {
        className: cx(
          {
            [classes.formRowWithLeftLabel]: labelPlacement === "left"
          },
          classes.formRow,
          className
        )
      },
      label ? /* @__PURE__ */ React.createElement(
        FormLabel,
        {
          focused: false,
          className: cx({
            [classes.formRowLabelCaption]: labelVariant === "caption",
            [classes.formRowLabelDefault]: labelVariant === "default"
          })
        },
        /* @__PURE__ */ React.createElement(LocalizedText, { label })
      ) : null,
      /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }),
      hint ? /* @__PURE__ */ React.createElement(MessageWithIcon, { className: classes.formRowHint, icon: CustomIcon.WarningOutline, label: hint }) : null
    );
  };
}
export {
  StyledInputProps,
  withStyledInputLabel
};
//# sourceMappingURL=StyledFormInputHoc.js.map
